import { render, staticRenderFns } from "./rename-account.vue?vue&type=template&id=c7e3d3ac&"
import script from "./rename-account.vue?vue&type=script&lang=ts&"
export * from "./rename-account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports